import { Col } from "react-bootstrap"
import ProductCard from "./ProductCard"
import { ProductPageDataQuery } from "@generated/graphql"
import { ProductSliderWrapper } from "../styled/ProductSlider"
import SliderNextArrow from "@modules/Common/components/SliderNextArrow"
import SliderPrevArrow from "@modules/Common/components/SliderPrevArrow"

interface IProductList {
  products: ProductPageDataQuery["newReleasedProducts"]
}

export default function ProductList({ products }: IProductList) {

  const settings = {
    infinite: true,
    speed: 500,
    nextArrow: <SliderNextArrow />,
    prevArrow: <SliderPrevArrow />,
    slidesToShow: 4,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1.2,
        },
      },
      {
        breakpoint: 625,
        settings: {
          slidesToShow: 1.2,
        },
      },
    ],
  }

  return (<>
    <ProductSliderWrapper {...settings}>
      {products.map((product, index) => <ProductCard key={index} product={product} />)}
    </ProductSliderWrapper>
  </>
  )
}
